import React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

const SEO = ({ description, lang, meta, title }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = title ? title + ' | ' + site.siteMetadata.title : site.siteMetadata.title

  return (
    <Helmet
      htmlAttributes={{
        lang: lang,
      }}
    >
      <meta charSet='utf-8' />
      <title>{ defaultTitle }</title>
      <meta name='description' content={ metaDescription } />
      <meta name='viewport' content='width=device-width, initial-scale=1.0, user-scalable=1.0, minimum-scale=1.0, maximum-scale=1.0' />
      <meta property="og:title" content={ defaultTitle } />
      <meta property="og:description" content={ metaDescription } />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={ defaultTitle } />
      <meta name="twitter:description" content={metaDescription} />
    </Helmet>
  )
}

export default SEO